export type SlashTrigger = {
  start: number
  end: number
  query: string
}

export function findSlashTrigger(text: string, cursorPosition: number): SlashTrigger | null {
  const cursor = Math.max(0, Math.min(cursorPosition, text.length))
  const beforeCursor = text.slice(0, cursor)
  const slashIndex = beforeCursor.lastIndexOf('/')
  if (slashIndex < 0) return null

  const previous = slashIndex > 0 ? text[slashIndex - 1] : ''
  if (previous && !/\s/.test(previous)) return null

  const query = text.slice(slashIndex + 1, cursor)
  if (/\s/.test(query)) return null

  const afterCursor = text.slice(cursor)
  const nextWhitespace = afterCursor.search(/\s/)
  const tokenEnd = nextWhitespace === -1 ? text.length : cursor + nextWhitespace
  return { start: slashIndex, end: tokenEnd, query }
}

export function commandNameFromDraft(text: string): string | null {
  // Match any complete /command token at start-of-string or after whitespace,
  // followed by whitespace or end-of-string. Return the last one found so
  // a skill typed deep in a multi-line message is still detected.
  const matches = [...text.matchAll(/(^|\s)\/([A-Za-z0-9][A-Za-z0-9_.-]*)(?=\s|$)/gm)]
  return matches.length > 0 ? (matches[matches.length - 1][2] ?? null) : null
}
